import { render, staticRenderFns } from "./CrmFeature.vue?vue&type=template&id=7d98b6a7&scoped=true&"
import script from "./CrmFeature.vue?vue&type=script&lang=js&"
export * from "./CrmFeature.vue?vue&type=script&lang=js&"
import style0 from "./CrmFeature.vue?vue&type=style&index=0&id=7d98b6a7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d98b6a7",
  null
  
)

export default component.exports